module.exports = __webpack_public_path__ + "static/img/1_6.6b00e97c.jpg";